// This file is auto generated by data-scripts/_helpers/runtime.ts
import commonWords from './commonWords.json';
import names from './names.json';
import wikipedia from './wikipedia.json';
import translations from './translations';
const dictionary = { commonWords, names, wikipedia };
export { dictionary, translations };
//# sourceMappingURL=index.js.map